import { Button, DatePicker, Form, Modal, Select } from "antd";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";
import { EmployeeRoleHistorySetup, getRoles } from "../../role/roleApis";
import { loadSingleStaff } from "../../../redux/rtk/features/user/userSlice";

const RoleEditSinglePopup = ({ data, setLoading }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { id } = useParams();
  const [rolesList, setRolesList] = useState(null);
  const { Option } = Select;

  useEffect(() => {
    getRoles()
      .then((data) => setRolesList(data))
      // .catch((error) => // console.log("Error loading roles:", error));
  }, []);

  useEffect(() => {
    if (isModalOpen && data) {
      form.setFieldsValue({
        RoleId: data.RoleName,
        EffectedFrom: data.EffectedFrom ? dayjs(data.EffectedFrom) : null,
        EffectedTo: data.EffectedTo ? dayjs(data.EffectedTo) : null,
        
      });
    }
  }, [isModalOpen, data, form]);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    form.resetFields();
  };

  const onFinish = async (values) => {
    try {
      setLoading(true);
      const response = await dispatch(EmployeeRoleHistorySetup({
        ...values,
        RoleHistoryId:data.RoleHistoryId,
        EmployeeId: id,
        DataStatus: 1,
      }));
      if (response.payload.message === "success") {
        dispatch(loadSingleStaff(id));
        setIsModalOpen(false);
        form.resetFields();
      }
    } catch (error) {
      // console.error("Error adding role history:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button onClick={showModal} className="mr-2">
        Edit
      </Button>
      <Modal
        title="Edit Role"
        open={isModalOpen}
        onCancel={handleCancel}
        footer={null}
      >
        <Form
          form={form}
          name="editRole"
          layout="vertical"
          onFinish={onFinish}
        >
          <Form.Item
            label="Role"
            name="RoleId"
            rules={[{ required: true, message: "Please select a role!" }]}
          >
            <Select 
              placeholder="Select role" 
              allowClear
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {rolesList?.map((role) => (
                <Option key={role.RoleId} value={role.RoleId}>
                  {role.RoleName}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label="Effective From"
            name="EffectedFrom"
            rules={[{ required: true, message: "Please enter the effective date!" }]}
          >
            <DatePicker />
          </Form.Item>
           <Form.Item
            label="Effective To"
            name="EffectedTo"
          >
            <DatePicker />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              Update
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default RoleEditSinglePopup;